import { render, staticRenderFns } from "./vt-loading-view.vue?vue&type=template&id=d15c1e00&scoped=true&"
import script from "./vt-loading-view.ts?vue&type=script&lang=ts&"
export * from "./vt-loading-view.ts?vue&type=script&lang=ts&"
import style0 from "./vt-loading-view.scss?vue&type=style&index=0&id=d15c1e00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15c1e00",
  null
  
)

export default component.exports